import React from 'react';
import type { ReactNode } from 'react';

import { LinkButton } from '@atlaskit/button/new';

import { useSessionData } from '@confluence/session-data';

type HTV2ActionCardLinkCTAProps = {
	onClick: () => void;
	href: string;
	children: ReactNode;
};
type CTAComponentProps = Omit<HTV2ActionCardLinkCTAProps, 'href'>;

const HTV2ActionCardLinkCTA = ({ onClick, href, children }: HTV2ActionCardLinkCTAProps) => {
	return (
		<LinkButton onClick={onClick} href={href} target="_blank">
			{children}
		</LinkButton>
	);
};

export const HTV2DownloadMobileAppCTA = ({ children, onClick }: CTAComponentProps) => {
	return (
		<HTV2ActionCardLinkCTA
			onClick={onClick}
			href="https://www.atlassian.com/software/confluence/mobile-app"
		>
			{children}
		</HTV2ActionCardLinkCTA>
	);
};

export const HTV2AddProfilePictureCTA = ({ children, onClick }: CTAComponentProps) => {
	const { userId } = useSessionData();
	return (
		<HTV2ActionCardLinkCTA onClick={onClick} href={`/wiki/people/${userId}`}>
			{children}
		</HTV2ActionCardLinkCTA>
	);
};

export const HTV2ChangeSiteThemeCTA = ({ children, onClick }: CTAComponentProps) => {
	return (
		<HTV2ActionCardLinkCTA onClick={onClick} href="/wiki/admin/look-and-feel/customize-navigation">
			{children}
		</HTV2ActionCardLinkCTA>
	);
};
